import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTop from '../../components/feature/ScrollToTop';
import Button from '../../components/base/Button';
import AnimatedSection from '../../components/base/AnimatedSection';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  const services = [
    {
      icon: 'ri-video-line',
      title: 'تصوير وإنتاج الفيديو',
      description: 'إنتاج فيديوهات احترافية عالية الجودة لجميع المناسبات والأغراض التجارية'
    },
    {
      icon: 'ri-movie-2-line',
      title: 'الموشن جرافيك',
      description: 'تصميم رسوم متحركة إبداعية تجذب الانتباه وتوصل رسالتك بفعالية'
    },
    {
      icon: 'ri-mic-line',
      title: 'التسجيل الصوتي',
      description: 'خدمات تسجيل صوتي احترافية في استوديوهات مجهزة بأحدث التقنيات'
    },
    {
      icon: 'ri-scissors-cut-line',
      title: 'المونتاج والإخراج',
      description: 'مونتاج احترافي وإخراج متقن يحول أفكارك إلى واقع مرئي مذهل'
    },
    {
      icon: 'ri-camera-line',
      title: 'التصوير الفوتوغرافي',
      description: 'التقاط لحظات استثنائية بجودة عالية للمناسبات والمنتجات'
    },
    {
      icon: 'ri-live-line',
      title: 'البث المباشر',
      description: 'حلول البث المباشر المتطورة للفعاليات والمؤتمرات'
    }
  ];

  const stats = [
    { number: '500+', label: 'مشروع مكتمل' },
    { number: '200+', label: 'عميل راضٍ' },
    { number: '8+', label: 'سنوات خبرة' },
    { number: '50+', label: 'جائزة وتقدير' }
  ];

  const portfolioItems = [
    {
      title: 'إعلان تجاري - شركة التقنية المتقدمة',
      category: 'إعلانات',
      image: 'https://public.readdy.ai/ai/img_res/05e0de3c9bded593daec7190cf12d6c5.jpg'
    },
    {
      title: 'فيلم وثائقي - التراث السعودي',
      category: 'وثائقيات',
      image: 'https://readdy.ai/api/search-image?query=Documentary%20film%20production%20showcasing%20Saudi%20Arabian%20heritage%20and%20culture%20with%20traditional%20architecture%2C%20desert%20landscapes%2C%20and%20cultural%20elements%20in%20cinematic%20quality&width=400&height=300&seq=2&orientation=landscape'
    },
    {
      title: 'تغطية مؤتمر الرياض للتقنية',
      category: 'فعاليات',
      image: 'https://readdy.ai/api/search-image?query=Professional%20event%20coverage%20of%20technology%20conference%20in%20Riyadh%20with%20modern%20venue%2C%20speakers%20on%20stage%2C%20audience%2C%20and%20professional%20video%20equipment%20setup&width=400&height=300&seq=3&orientation=landscape'
    },
    {
      title: 'حملة إعلانية - مهرجان الثقافة',
      category: 'إعلانات',
      image: 'https://readdy.ai/api/search-image?query=Cultural%20festival%20advertising%20campaign%20production%20with%20vibrant%20colors%2C%20traditional%20Saudi%20elements%2C%20modern%20design%2C%20and%20professional%20media%20production%20equipment&width=400&height=300&seq=4&orientation=landscape'
    }
  ];

  const whyChooseUs = [
    {
      icon: 'ri-award-line',
      title: 'جودة استثنائية',
      description: 'نلتزم بأعلى معايير الجودة في كل مشروع نقوم به'
    },
    {
      icon: 'ri-team-line',
      title: 'فريق محترف',
      description: 'فريق من المبدعين والخبراء في مجال الإنتاج الإعلامي'
    },
    {
      icon: 'ri-time-line',
      title: 'التسليم في الوقت',
      description: 'نحترم المواعيد ونسلم مشاريعنا في الأوقات المحددة'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'دعم مستمر',
      description: 'نقدم الدعم والمتابعة حتى بعد انتهاء المشروع'
    }
  ];

  const clients = [
    'شركة أرامكو السعودية',
    'مجموعة سامبا المالية',
    'شركة الاتصالات السعودية',
    'مجموعة المراعي',
    'بنك الراجحي',
    'شركة سابك'
  ];

  const handleServiceRequest = () => {
    navigate('/contact');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20media%20production%20studio%20with%20modern%20video%20equipment%2C%20cameras%2C%20lighting%20setup%2C%20and%20creative%20workspace%20showcasing%20Saudi%20Arabian%20media%20industry%20with%20cinematic%20atmosphere%20and%20professional%20ambiance&width=1920&height=1080&seq=5&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              نحو رؤية إعلامية مبدعة
              <span className="block text-yellow-500">تعكس واقعك باحتراف</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
              شركة إنتاج إعلامي سعودية رائدة تقدم حلولاً إبداعية متكاملة في مجال الإنتاج المرئي والصوتي
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button variant="primary" size="lg" href="/about">
                تعرف علينا
              </Button>
              <Button variant="outline" size="lg" href="/portfolio">
                شاهد أعمالنا
              </Button>
            </div>
          </div>
        </div>
        
        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">من نحن</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              نحن شركة إنتاج إعلامي سعودية متخصصة في تقديم حلول إبداعية شاملة تجمع بين الإبداع والتقنية والاحتراف
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center group">
              <div className="w-20 h-20 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-lightbulb-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">الإبداع</h3>
              <p className="text-gray-600 leading-relaxed">
                نؤمن بقوة الإبداع في تحويل الأفكار إلى واقع مرئي يترك أثراً إيجابياً
              </p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-medal-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">الجودة</h3>
              <p className="text-gray-600 leading-relaxed">
                نلتزم بأعلى معايير الجودة في كل تفصيل من تفاصيل العمل الإنتاجي
              </p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-eye-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">الرؤية</h3>
              <p className="text-gray-600 leading-relaxed">
                رؤيتنا هي أن نكون الخيار الأول للإنتاج الإعلامي في المملكة والمنطقة
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">خدماتنا</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              نقدم مجموعة شاملة من الخدمات الإعلامية المتخصصة لتلبية جميع احتياجاتكم
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <AnimatedSection 
                key={index} 
                animation="scaleUp" 
                delay={index * 100}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
              >
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center mb-3">
                      <i className={`${service.icon} text-xl text-white`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-white">{service.title}</h3>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={handleServiceRequest}
                  >
                    اطلب الخدمة الآن
                  </Button>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">إنجازاتنا بالأرقام</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              أرقام تتحدث عن مسيرتنا الناجحة وثقة عملائنا بنا
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-6xl font-bold text-yellow-500 mb-2">
                  {stat.number}
                </div>
                <div className="text-lg text-gray-300">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Portfolio Preview */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">معرض أعمالنا</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              نماذج من أعمالنا المتميزة التي تعكس خبرتنا وإبداعنا في مجال الإنتاج الإعلامي
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {portfolioItems.map((item, index) => (
              <div key={index} className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 right-4 text-white">
                    <span className="inline-block bg-yellow-500 text-black px-3 py-1 rounded-full text-sm font-medium mb-2">
                      {item.category}
                    </span>
                    <h3 className="font-bold text-lg leading-tight">{item.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center">
            <Button variant="primary" size="lg" href="/portfolio">
              شاهد جميع أعمالنا
            </Button>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">لماذا نحن؟</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              ما يميزنا عن غيرنا ويجعلنا الخيار الأمثل لمشاريعكم الإعلامية
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {whyChooseUs.map((item, index) => (
              <div key={index} className="text-center group">
                <div className="w-20 h-20 bg-gradient-to-r from-yellow-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${item.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Clients Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">عملاؤنا وشركاؤنا</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              نفتخر بثقة كبرى الشركات والمؤسسات في المملكة
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {clients.map((client, index) => (
              <div key={index} className="bg-gray-800 rounded-lg p-6 text-center hover:bg-gray-700 transition-colors duration-300">
                <div className="text-yellow-500 font-bold text-lg">{client}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-yellow-600 to-red-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">هل أنت مستعد لبدء مشروعك؟</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
            تواصل معنا اليوم واحصل على استشارة مجانية لمشروعك الإعلامي القادم
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="outline" size="lg" href="/contact" className="bg-white text-gray-900 hover:bg-gray-100">
              تواصل معنا الآن
            </Button>
            <Button variant="secondary" size="lg" href="/services">
              استكشف خدماتنا
            </Button>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
    </div>
  );
}
